// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { UIModelBaseElement } from './UIModelBaseElement';
import { UIModelComponent } from './UIModelComponent';
import { UIPage } from './UIPage';
import { UIView } from './UIView';
import { EVOAction } from './EVOAction';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 界面按钮 实体类
 * 视图或页面上面的按钮
 */
export class UIButton extends UIModelBaseElement {
  /** 编码 : 有含义的字母编码，用于程序中使用，唯一 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 是否受控 : 不受控的按钮，任何访问者都可见并可访问 */
  private _isControl: boolean;

  /** 设置：是否受控 */
  public get isControl() {
    return this._isControl;
  }

  /** 获取：是否受控 */
  public set isControl(value: boolean) {
    this._isControl = value;
  }

  /** 是否可移除 : 是否可移除，不可移除的按钮不提供删除功能，要求移除后对页面功能没有影响 */
  private _isRemovable: boolean;

  /** 设置：是否可移除 */
  public get isRemovable() {
    return this._isRemovable;
  }

  /** 获取：是否可移除 */
  public set isRemovable(value: boolean) {
    this._isRemovable = value;
  }

  /** 已移除 : 已移除的按钮不可见 */
  private _removed: boolean;

  /** 设置：已移除 */
  public get removed() {
    return this._removed;
  }

  /** 获取：已移除 */
  public set removed(value: boolean) {
    this._removed = value;
  }

  /** 无权限可见 : 当受控按钮无权限的时候，是否可见，true则为禁用状态，false则不显示 */
  private _visibleNoPermission: boolean;

  /** 设置：无权限可见 */
  public get visibleNoPermission() {
    return this._visibleNoPermission;
  }

  /** 获取：无权限可见 */
  public set visibleNoPermission(value: boolean) {
    this._visibleNoPermission = value;
  }

  /** 是否有效 : 是否有效，无效的按钮前端不可见，当操作删除，其对应的按钮将被设置为false */
  private _isValid: boolean;

  /** 设置：是否有效 */
  public get isValid() {
    return this._isValid;
  }

  /** 获取：是否有效 */
  public set isValid(value: boolean) {
    this._isValid = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: UIModelComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: UIModelComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 页面 的ID */
  private _page_ID: string;

  /** 获取：页面 的ID */
  public get page_ID() {
    return this._page_ID;
  }

  /** 设置：页面 的ID */
  public set page_ID(value: string) {
    this._page_ID = value;
  }

  /** 页面  */
  private _page: UIPage;

  /** 获取：页面  */
  public get page() {
    return this._page;
  }

  /** 设置：页面  */
  public set page(value: UIPage) {
    this._page = value;
    if (value !== null) {
      this.page_ID = value.id;
    } else {
      this.page_ID = '';
    }
  }

  /** 视图 的ID */
  private _view_ID: string;

  /** 获取：视图 的ID */
  public get view_ID() {
    return this._view_ID;
  }

  /** 设置：视图 的ID */
  public set view_ID(value: string) {
    this._view_ID = value;
  }

  /** 视图  */
  private _view: UIView;

  /** 获取：视图  */
  public get view() {
    return this._view;
  }

  /** 设置：视图  */
  public set view(value: UIView) {
    this._view = value;
    if (value !== null) {
      this.view_ID = value.id;
    } else {
      this.view_ID = '';
    }
  }

  /** 操作 的ID */
  private _action_ID: string;

  /** 获取：操作 的ID */
  public get action_ID() {
    return this._action_ID;
  }

  /** 设置：操作 的ID */
  public set action_ID(value: string) {
    this._action_ID = value;
  }

  /** 操作  */
  private _action: EVOAction;

  /** 获取：操作  */
  public get action() {
    return this._action;
  }

  /** 设置：操作  */
  public set action(value: EVOAction) {
    this._action = value;
    if (value !== null) {
      this.action_ID = value.id;
    } else {
      this.action_ID = '';
    }
  }

  constructor() {
    super();
    this._code = '';
    this._isControl = false;
    this._isRemovable = false;
    this._removed = false;
    this._visibleNoPermission = false;
    this._isValid = true;
    this._component_ID = '';
    this._component = null;
    this._page_ID = '';
    this._page = null;
    this._view_ID = '';
    this._view = null;
    this._action_ID = '';
    this._action = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UIButton, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.code = element.code;
      this.isControl = element.isControl;
      this.isRemovable = element.isRemovable;
      this.removed = element.removed;
      this.visibleNoPermission = element.visibleNoPermission;
      this.isValid = element.isValid;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.page_ID = element.page_ID;
      if (hasReference && element.page !== null) {
        this.page = element.page;
      }
      this.view_ID = element.view_ID;
      if (hasReference && element.view !== null) {
        this.view = element.view;
      }
      this.action_ID = element.action_ID;
      if (hasReference && element.action !== null) {
        this.action = element.action;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.code = json.Code;
    this.isControl = json.IsControl;
    this.isRemovable = json.IsRemovable;
    this.removed = json.Removed;
    this.visibleNoPermission = json.VisibleNoPermission;
    this.isValid = json.IsValid;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = UIModelComponent.Create(json.Component);
    // }
    this.page_ID = json.Page_ID;
    // if (json.Page !== null) {
    //   this.page = UIPage.Create(json.Page);
    // }
    this.view_ID = json.View_ID;
    // if (json.View !== null) {
    //   this.view = UIView.Create(json.View);
    // }
    this.action_ID = json.Action_ID;
    // if (json.Action !== null) {
    //   this.action = EVOAction.Create(json.Action);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Code = this.code;
    json.IsControl = this.isControl;
    json.IsRemovable = this.isRemovable;
    json.Removed = this.removed;
    json.VisibleNoPermission = this.visibleNoPermission;
    json.IsValid = this.isValid;
    json.Component_ID = this.component_ID;
    json.Page_ID = this.page_ID;
    json.View_ID = this.view_ID;
    json.Action_ID = this.action_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'isControl', '是否受控', EnumDataType.Bool, this.isControl, true, '不受控的按钮，任何访问者都可见并可访问', '', '');
    context.addRow('基本属性', 'visibleNoPermission', '无权限可见', EnumDataType.Bool, this.visibleNoPermission, true, '当受控按钮无权限的时候，是否可见，true则为禁用状态，false则不显示', '', '');
    return context;
  }

  static Create(json: any): UIButton {
    const uIButton = new UIButton();
    uIButton.Deserialize(json);
    uIButton.json = json;
    return uIButton;
  }
}
